export type Boundary = { min: number; max: number }
export type Value = { start: number; end: number }

export function sanitize(range: Value, boundary: Boundary): Value {
  const clampedStart = Math.min(boundary.max, Math.max(boundary.min, range.start))
  const clampedEnd = Math.min(boundary.max, Math.max(boundary.min, range.end))
  return {
    start: Math.min(clampedStart, clampedEnd),
    end: Math.max(clampedStart, clampedEnd),
  }
}

export function getPercentOfBoundary(range: Value, boundary: Boundary): Value {
  const width = boundary.max - boundary.min
  return {
    start: Math.round(((range.start - boundary.min) / width) * 100),
    end: Math.round(((range.end - boundary.min) / width) * 100),
  }
}
